package games.polyclub.website.frontend.store

import games.polyclub.frontend.lib.chartjs.ChartJs
import games.polyclub.frontend.lib.chartjs.initialize
import games.polyclub.frontend.lib.react.ga4.GA4
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.utils.ErrorHandlingScope
import games.polyclub.message.PronounDetector
import games.polyclub.service.profile.api.PlayerProfile
import games.polyclub.tool.functional.Option
import games.polyclub.website.frontend.store.context.AuthProvider
import games.polyclub.website.frontend.store.context.BreadcrumbsProvider
import games.polyclub.website.frontend.store.context.CartProvider
import games.polyclub.website.frontend.store.context.UserPreferencesProvider
import kotlinext.js.require
import react.Props
import react.dom.client.createRoot
import react.dom.html.ReactHTML.b
import react.router.PathRoute
import react.router.Routes
import react.router.dom.HashRouter
import web.dom.document

private val AppWrapper = SFC<Props> {
    HashRouter {
        AuthProvider {
            BreadcrumbsProvider {
                UserPreferencesProvider {
                    CartProvider {
                        Routes {
                            PathRoute {
                                path = "/*"
                                //Component = withTracker(App.new())
                                element = App.new()
                                errorElement = b.new {
                                    +"Erro no App principal :("
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

fun main() {
    GA4.initialize("G-LB0HQHZD2P")
    require("admin-lte")
    require("bootstrap")
    require("ion-rangeslider")
    require("ion-rangeslider/css/ion.rangeSlider.min.css")
    require("@fortawesome/fontawesome-free/css/all.min.css")
    require("ionicons/dist/css/ionicons.min.css")
    require("tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css")
    require("icheck-bootstrap/icheck-bootstrap.min.css")
    // overlayScrollbars CSS is already included by admin-lte
    require("daterangepicker/daterangepicker.css")
    require("summernote/dist/summernote-bs4.min.css")
    require("./css/store.scss")

    ChartJs.initialize()

    PronounDetector.register {
        (it as? Option<*>)?.getOrNull()
    }

    PronounDetector.register {
        (it as? PlayerProfile)?.preferredPronoun?.getOrNull()
    }

    listOf(
        document.body,
        document.getElementById("wrapper"),
        document.getElementsByTagName("html").item(0),
    ).forEach {
        it?.className = it?.className?.replace("forced_height_100", "") ?: ""
        it?.asDynamic()?.style?.height = ""
    }

    val rootElement = document.getElementById("wrapper")!!
    val root = createRoot(rootElement)

    root.render(AppWrapper.new())
}

val appScope = ErrorHandlingScope(name = "Store")
